
import GwButton from '~/patterns/atoms/button/button.vue';

export default {
    components: {
        GwButton,
    },
    props: {
        filters: {
            type: Array,
            default: () => { return []; }
        },
        activeFilter: {
            type: String,
            default: ''
        }
    },
    methods: {
        applyFilter(slug) {
            if (this.checkActive(slug)) {
                this.$emit('filterChanged', null);
            } else {
                this.$emit('filterChanged', slug);
            }
        },
        checkActive(slug) {
            const selected = this.activeFilter;
            return slug === selected;
        }
    }
};
